import { AuctionInfoWindowData, AuctionNearMeHit } from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';
import { getCatalogUrl } from '@/utils/urls';
import { shortFormatDate } from '@liveauctioneers/caterwaul-components/lib/utils/dates';

const groupAuctionsByDate = (
    hits: AuctionNearMeHit[],
    { _geoloc: selectedGeoloc }: AuctionNearMeHit
): AuctionInfoWindowData => {
    const groupedAuctions: AuctionInfoWindowData = {};
    const { lat: selectedLat, lng: selectedLng } = selectedGeoloc;
    hits.filter(({ _geoloc }) => _geoloc.lat === selectedLat && _geoloc.lng === selectedLng).forEach(
        ({ Catalog, SaleStart }) => {
            const auctionDate = shortFormatDate(SaleStart);
            const title = Catalog.Title;
            const link = getCatalogUrl(Catalog.ID, title);

            if (!groupedAuctions[auctionDate]) {
                groupedAuctions[auctionDate] = [];
            }
            groupedAuctions[auctionDate].push({
                link,
                title,
            });
        }
    );
    return groupedAuctions;
};

const getUpcomingAuctionsContent = (data: AuctionInfoWindowData): string =>
    Object.keys(data)
        .map((date) => {
            const mappedAuctions = data[date].map(({ link, title }) => {
                return `
                    <div>
                        <a target='_blank' href='${link}' style='text-decoration: underline; font-weight: normal;'>${title}</a>
                    </div>
                `;
            });
            return `
                <div style='margin-bottom: 10px'>
                    <div style='font-weight: normal;'>${date}</div>
                    ${mappedAuctions}
                </div>
            `;
        })
        .join('');

// Google Map's InfoWindow requires a string for its content. So, unfortunately, this is kinda needed
export const getInfoWindowContent = (selectedHit: AuctionNearMeHit, availableHits: AuctionNearMeHit[]): string => {
    const houseName = selectedHit.House.Name;
    const upcomingAuctions: AuctionInfoWindowData = groupAuctionsByDate(availableHits, selectedHit);

    return `
        <article style='padding: 10px;'>
            <header>
                <h4 style='margin-bottom: 5px;'>${houseName}</h4>
            </header>
            <section>
                ${getUpcomingAuctionsContent(upcomingAuctions)}
            </section>
        </article>
    `;
};
